// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LU92VTkzcmqCHNKnSh2J {
  margin-top: 4rem;
}

.pPNCbze5RMglbMYUuqsQ {
  font-size: 2rem;
  font-weight: 900;
  line-height: 2.25rem;
}

.ua78zD9mZUeNKfi1vnUZ {
  margin-top: 2.5rem;
}

.ua8YtTi9n8M5eDh3Kzxo {
  margin-top: 3.125rem;
  width: 100%;
  height: auto;
  max-height: 26.875rem;
  object-fit: cover;
  box-shadow: var(--black-012);
  border-radius: var(--panel-narrow-border-radius);
}

.NKeV2xQgmXtXWxzVxYdl {
  margin-top: 2.5rem;
  display: flex;
  grid-gap: 1.25rem;
  gap: 1.25rem;
  justify-content: space-between;
  flex-wrap: wrap;
}

.D99tzo9hiVLNFRUMJzQW.D99tzo9hiVLNFRUMJzQW {
  margin-top: 1.5rem;
}

.ntMhTY7DLQh4TROwNZE0 {
  margin-top: 4rem;
  width: 100%;
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .LU92VTkzcmqCHNKnSh2J {
    margin-top: 3rem;
  }

  .pPNCbze5RMglbMYUuqsQ {
    font-size: 1.5rem;
    line-height: 1.75rem;
  }

  .ua78zD9mZUeNKfi1vnUZ {
    margin-top: 1.5rem;
  }

  .ua8YtTi9n8M5eDh3Kzxo {
    margin-top: 1.5rem;
  }
}

@media only screen and
  (max-width: 639px) {
  .LU92VTkzcmqCHNKnSh2J {
    margin-top: 3rem;
  }

  .pPNCbze5RMglbMYUuqsQ {
    font-size: 1.5rem;
    line-height: 1.75rem;
  }

  .ua78zD9mZUeNKfi1vnUZ {
    margin-top: 1.5rem;
  }

  .ua8YtTi9n8M5eDh3Kzxo {
    margin-top: 1.5rem;
  }

  .NKeV2xQgmXtXWxzVxYdl {
    margin-top: 1.5rem;
  }
    .ntMhTY7DLQh4TROwNZE0.ntMhTY7DLQh4TROwNZE0 {
      width: 100%;
    }

  .ntMhTY7DLQh4TROwNZE0 {

    margin-top: 2.75rem;
    min-width: 21.4375rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/BlogArticleBlockItem/BlogArticleBlockItem.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAiB;AACnB;;AAEA;EACE,kBAAgB;AAClB;;AAEA;EACE,oBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,qBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;EAC5B,gDAAgD;AAClD;;AAEA;EACE,kBAAgB;EAChB,aAAa;EACb,iBAAS;EAAT,YAAS;EACT,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,kBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAe;IACf,oBAAiB;EACnB;;EAEA;IACE,kBAAgB;EAClB;;EAEA;IACE,kBAAgB;EAClB;AACF;;AAEA;;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAe;IACf,oBAAiB;EACnB;;EAEA;IACE,kBAAgB;EAClB;;EAEA;IACE,kBAAgB;EAClB;;EAEA;IACE,kBAAgB;EAClB;IAGE;MACE,WAAW;IACb;;EAHF;;IAKE,mBAAgB;IAChB,qBAAgB;EAClB;AACF","sourcesContent":[".blogArticleBlockItem {\n  margin-top: 64px;\n}\n\n.title {\n  font-size: 32px;\n  font-weight: 900;\n  line-height: 36px;\n}\n\n.description {\n  margin-top: 40px;\n}\n\n.blockImage {\n  margin-top: 50px;\n  width: 100%;\n  height: auto;\n  max-height: 430px;\n  object-fit: cover;\n  box-shadow: var(--black-012);\n  border-radius: var(--panel-narrow-border-radius);\n}\n\n.coloredBlocks {\n  margin-top: 40px;\n  display: flex;\n  gap: 20px;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.coloredBlockItem.coloredBlockItem {\n  margin-top: 24px;\n}\n\n.blockWithHand {\n  margin-top: 64px;\n  width: 100%;\n}\n\n@media (--tablet) {\n  .blogArticleBlockItem {\n    margin-top: 48px;\n  }\n\n  .title {\n    font-size: 24px;\n    line-height: 28px;\n  }\n\n  .description {\n    margin-top: 24px;\n  }\n\n  .blockImage {\n    margin-top: 24px;\n  }\n}\n\n@media (--mobile) {\n  .blogArticleBlockItem {\n    margin-top: 48px;\n  }\n\n  .title {\n    font-size: 24px;\n    line-height: 28px;\n  }\n\n  .description {\n    margin-top: 24px;\n  }\n\n  .blockImage {\n    margin-top: 24px;\n  }\n\n  .coloredBlocks {\n    margin-top: 24px;\n  }\n\n  .blockWithHand {\n    &.blockWithHand {\n      width: 100%;\n    }\n\n    margin-top: 44px;\n    min-width: 343px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blogArticleBlockItem": `LU92VTkzcmqCHNKnSh2J`,
	"title": `pPNCbze5RMglbMYUuqsQ`,
	"description": `ua78zD9mZUeNKfi1vnUZ`,
	"blockImage": `ua8YtTi9n8M5eDh3Kzxo`,
	"coloredBlocks": `NKeV2xQgmXtXWxzVxYdl`,
	"coloredBlockItem": `D99tzo9hiVLNFRUMJzQW`,
	"blockWithHand": `ntMhTY7DLQh4TROwNZE0`
};
export default ___CSS_LOADER_EXPORT___;
